import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { theme } from "./styles/theme";
import "dayjs/locale/nb";

import "./style.css";
import "./i18n";

const queryClient = new QueryClient();

const App = () => {
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="nb-no">
			<QueryClientProvider client={queryClient}>
				<ThemeProvider theme={theme}>
					<CssBaseline />
					<RouterProvider router={router} />
				</ThemeProvider>
			</QueryClientProvider>
		</LocalizationProvider>
	);
};

export default App;
